import { api, withReducer } from './services';

import { PLATFORMS } from './constants';

const SHOW_MODAL = 'footer/SHOW_MODAL';
const HIDE_MODAL = 'footer/HIDE_MODAL';
const SHOW_ERROR = 'footer/SHOW_ERROR';
const CHANGE_EMAIL_ADDRESS = 'footer/CHANGE_EMAIL_ADDRESS';

const validEmailPattern = /\S+@\S+\.\S+/;

const isValidEmail = emailAddress =>
  emailAddress !== '' && validEmailPattern.test(emailAddress);

const hideModal = () => dispatch => {
  dispatch({ type: HIDE_MODAL });
};

export const subscribeToNewsletter = (email, baseUrl, releaseBodyOverflow) => ({
  payload: {
    url: `${baseUrl}/ajax/subscribe_newsletter`,
    method: 'POST',
    data: { email },
    onSuccess: () => ({
      type: SHOW_MODAL,
    }),
    onFailure: () => {
      releaseBodyOverflow();

      return {
        type: SHOW_ERROR,
        payload: { error: 'invalid' },
      };
    },
  },
});

const onChangeEmailAddress = emailAddress => dispatch => {
  dispatch({
    type: CHANGE_EMAIL_ADDRESS,
    payload: {
      emailAddress,
    },
  });
};

export const actions = {
  submitEmail: (email, baseUrl, releaseBodyOverflow) => dispatch => {
    if (isValidEmail(email)) {
      api(dispatch, subscribeToNewsletter(email, baseUrl, releaseBodyOverflow));
    } else {
      dispatch({
        type: SHOW_ERROR,
        payload: { error: email === '' ? 'empty' : 'invalid' },
      });
      releaseBodyOverflow();
    }
  },
  hideModal: () => dispatch => hideModal()(dispatch),
  onChangeEmailAddress: emailAddress => dispatch =>
    onChangeEmailAddress(emailAddress)(dispatch),
};

export const initialState = {
  isB2B: false,
  isAuthenticated: false,
  isModalVisible: false,
  emailAddress: '',
  baseUrl: '',
  platform: PLATFORMS.FRANCE,
  error: null,
};

export const actionHandlers = {
  [SHOW_MODAL]: state => {
    return {
      ...state,
      isModalVisible: true,
    };
  },
  [HIDE_MODAL]: state => {
    return {
      ...state,
      isModalVisible: false,
      emailAddress: '',
    };
  },
  [CHANGE_EMAIL_ADDRESS]: (state, action) => {
    const { emailAddress } = action.payload;

    return {
      ...state,
      emailAddress,
      error: null,
    };
  },
  [SHOW_ERROR]: (state, action) => {
    const { error } = action.payload;

    return {
      ...state,
      error,
    };
  },
};

export const reducer = withReducer(initialState, actionHandlers);
